import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Image } from 'components/core/Image';
import ScrollArrow from 'assets/images/icons/psp/scroll-arrow.svg';
import DisabledScrollArrow from 'assets/images/icons/psp/arrow-disabled.svg';
import { isLarge } from 'utils/breakpoints';
import './ScrollWrapper.scss';

export default function ScrollWrapper({
	children,
	className,
	scrollFactor = 1,
	slug,
	scrollable = true,
}) {
	const [disableLeftScroll, setDisableLeftScroll] = useState(true);
	const [disableRightScroll, setDisableRightScroll] = useState(true);
	const [width, setWidth] = useState(0);
	const scrollRef = useRef(null);

	useEffect(() => {
		setWidth(window.innerWidth);
		handleScroll();
	}, []);

	const handleScroll = () => {
		if (scrollRef.current) {
			const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;

			setDisableLeftScroll(scrollLeft <= 0);
			setDisableRightScroll(scrollLeft + clientWidth >= scrollWidth - 5);
		}
	};

	const scrollByAmount = (amount) => () => {
		scrollRef.current?.scrollBy({
			left: amount,
			behavior: 'smooth',
		});
	};


	const scrollOffset = isLarge(width)
		? 360 * scrollFactor
		: 260 * scrollFactor;

	return (
		<div className={classnames('scroll-wrapper', className, {
			'not-scrollable': !scrollable,
		})}>
		<Image
				src={disableLeftScroll ? DisabledScrollArrow : ScrollArrow}
				className={classnames('scroll-arrow left-arrow', {
					disabled: disableLeftScroll,
				})}
				onClick={
					disableLeftScroll ? null : scrollByAmount(-scrollOffset)
				}
				alt="scroll left"
			/>
			<Image
				src={disableRightScroll ? DisabledScrollArrow : ScrollArrow}
				className={classnames('scroll-arrow right-arrow', {
					disabled: disableRightScroll,
				})}
				onClick={
					disableRightScroll ? null : scrollByAmount(scrollOffset)
				}
				alt="scroll right"
			/>
			<div
				ref={scrollRef}
				onScroll={handleScroll}
				className={classnames('scrollable-container', slug, {
					"not-scrollable": !scrollable,
				})}
			>
				{children}
			</div>
		</div>
	);
}

ScrollWrapper.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	scrollFactor: PropTypes.number,
	slug: PropTypes.string,
	scrollable: PropTypes.bool
};
